import { useState } from 'react'
import EndUsersSetup from './end-user-setup'
import EndUsersTest from './end-users-test'
import { Tabs, TabItem } from '@/components/tabs'
import { useOutletContext } from 'react-router-dom'
import { GetCampaignFragment } from '@/types/campaign'
import { CampaignStatus } from '@/schema/campaign-details.schema'

export default function EndUsers() {
  const { campaign } = useOutletContext<{ campaign: GetCampaignFragment }>()

  // Disable Test End Users tab when campaign is active, completed, or scheduled
  const isTestDisabled =
    campaign?.campaignStatus === CampaignStatus.active ||
    campaign?.campaignStatus === CampaignStatus.completed || campaign?.campaignStatus === CampaignStatus.scheduled


  const [campaignState, setCampaignState] = useState(isTestDisabled ? 'real' : 'test')

  const handleTabChange = (value: string) => {
    setCampaignState(value)
  }


  const tabs: TabItem[] = [
    {
      value: 'test',
      label: 'Test End Users',
      disabled: isTestDisabled,
    },
    {
      value: 'real',
      label: 'Real End Users',
    },
  ]

  return (
    <div className="w-full">
      <Tabs
        tabs={tabs}
        defaultValue={campaignState}
        className="w-full mb-8"
        onChange={handleTabChange}
      />
      {campaignState === 'test' ? <EndUsersTest isTestDisabled={isTestDisabled} /> : <EndUsersSetup />}
    </div>
  )
}
